<div class="confirm-dialog-wrapper">
    <h1 id="confirmation-header" *ngIf="header">
        {{header}}
    </h1>

    <div class="title">
        <span [innerHTML]="target"></span><ng-container *ngIf="notificationLink"></ng-container>
    </div>

    <div class="button-row">
        <button mat-raised-button color="primary" class="confirm-btn" (click)="onSubmit()">Yes</button>
        <button mat-button class="discard-btn ml-16" (click)="onCancel()">No</button>
    </div>
</div>
